"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const component_1 = require("../packages/component-framework/component");
const createSwiper_1 = __importDefault(require("../helpers/createSwiper"));
class HeroBanner extends component_1.Component {
    constructor(element) {
        super(element);
        this.registerBanner();
    }
    registerBanner() {
        createSwiper_1.default(this.element, {
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
        });
    }
}
exports.default = HeroBanner;
HeroBanner.selector = '.module-hero-banner .swiper-container';
